// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/4011
import type { PAPEventGeneric } from "../base/event";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { SearchRelevanceRubric } from "../enums/search_relevance_rubric";

// Event_name: 'eng.dash_search_result_judge_relevance'
// Description: Event is fired when a judge LLM rates the quality of search results for a given query to dash.
// Owner: dash-exp-find-and-discover
export type Eng_DashSearchResultJudgeRelevance = PAPEventGeneric<
  'dash',
  'eng',
  'dash_search_result_judge_relevance',
  {
    // the start time of the event in ms
    startTimeMs?: number;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // rubric which a search result is graded against
    searchRelevanceRubric?: SearchRelevanceRubric;
    // prompt used to grade the relevance of this search result. Generally it is selected form a set of predetermined prompts, but users can write their own prompts.
    searchRelevancePrompt?: string;
    // The contents of a search query
    queryString?: string;
    // Identifier for item being suggested by Dash ML
    itemId?: string;
    // title of a search result
    itemTitle?: string;
    // number rating
    rating?: number;
    // explanation of why a certain rating was given for search relevance, generated by an LLM judge
    searchRelevanceExplanation?: string;
  }
>;

export function PAP_Eng_DashSearchResultJudgeRelevance(properties?: Eng_DashSearchResultJudgeRelevance['properties']): Eng_DashSearchResultJudgeRelevance {
  return <Eng_DashSearchResultJudgeRelevance>{
    class: 'dash',
    action: 'eng',
    object: 'dash_search_result_judge_relevance',
    properties,
  };
}
